import {
  Collapsible,
  CopyToClipboardButton,
  FlexBox,
  IconButton,
  Text,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { MessageSourceLink } from 'lib-shared-legacy-types';
import { memo, useState } from 'react';

type ConversationSourceLinksProps = {
  sourceLinks: MessageSourceLink[];
};

export const ConversationSourceLinks = memo(function ConversationSourceLinks({
  sourceLinks,
}: ConversationSourceLinksProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FlexBox padding="100 300" flexDirection="column">
      <Collapsible
        isOpen={isOpen}
        header={
          <FlexBox alignItems="center" gap="100">
            <Text.Paragraph as="div" color="secondary" variant="3">
              Related sources
            </Text.Paragraph>
            <IconButton
              icon={isOpen ? 'angle-up' : 'angle-down'}
              variant="tertiary"
              onClick={() => setIsOpen(!isOpen)}
            />
          </FlexBox>
        }
      >
        <FlexBox flexDirection="column">
          {sourceLinks.map((sourceLink, index) => (
            <FlexBox
              flexDirection="row"
              key={index}
              alignItems="center"
              width="100%"
              padding="0 0 0 300"
            >
              <Text.Paragraph
                as="div"
                color="secondary"
                variant="4"
                style={{ width: '100%' }}
              >
                {sourceLink.title}
              </Text.Paragraph>
              <Tooltip dark content="Copy link">
                <CopyToClipboardButton
                  textToCopy={sourceLink.url}
                  tooltip={false}
                  clickedProps={{ icon: 'done' }}
                  buttonProps={{ variant: 'tertiary', icon: 'link' }}
                />
              </Tooltip>
              <Tooltip dark content="Open link in a new tab">
                <IconButton
                  icon="external-link"
                  variant="tertiary"
                  onClick={() => window.open(sourceLink.url, '_blank')}
                />
              </Tooltip>
            </FlexBox>
          ))}
        </FlexBox>
      </Collapsible>
    </FlexBox>
  );
});
